/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2

var DESK_VIDEO_BANNER_MOBILE_QUERY = window.matchMedia('(max-width: 799px)');
var DESK_VIDEO_BANNER_REDUCED_MOTION_QUERY = window.matchMedia('(prefers-reduced-motion: reduce)');
var DESK_VIDEO_BANNER_FOCUSABLE = 'button, [href], iframe, video[controls], [tabindex]:not([tabindex="-1"])';

window.deskVideoBannerState = window.deskVideoBannerState || {
  isReady: false,
  $activePopup: null,
  $activeTrigger: null,
  releaseFocusTrap: null,
  visibilityObserver: null
};

function deskVideoBannerSafePlay(videoElement) {
  var playPromise = videoElement.play();
  if (playPromise && playPromise.catch) playPromise.catch(function () {});
}

function deskVideoBannerSyncBackgroundVideos(sectionElement) {
  var $section = $(sectionElement);
  var currentBreakpoint = DESK_VIDEO_BANNER_MOBILE_QUERY.matches ? 'mobile' : 'desktop';
  var shouldPlay = $section.is('[data-video-banner-visible]') &&
    !$section.is('[data-video-banner-popup-open]') &&
    !document.hidden &&
    !DESK_VIDEO_BANNER_REDUCED_MOTION_QUERY.matches;

  $section.find('[data-video-banner-bg]').each(function (index, videoElement) {
    var $backgroundVideo = $(videoElement);
    var videoBreakpoint = $backgroundVideo.attr('data-video-banner-mq');
    var matchesBreakpoint = videoBreakpoint === 'all' || videoBreakpoint === currentBreakpoint;

    if (!matchesBreakpoint || !shouldPlay) {
      if (!videoElement.paused) videoElement.pause();
      return;
    }
    if (!$backgroundVideo.attr('src')) {
      $backgroundVideo.attr('src', $backgroundVideo.attr('data-video-banner-src'));
    }
    deskVideoBannerSafePlay(videoElement);
  });
}

function deskVideoBannerSyncAllSections() {
  $('[data-video-banner]').each(function (index, sectionElement) {
    deskVideoBannerSyncBackgroundVideos(sectionElement);
  });
}

function deskVideoBannerHandleIntersect(entries) {
  entries.forEach(function (entry) {
    var $section = $(entry.target);

    if (entry.isIntersecting) {
      $section.attr('data-video-banner-visible', '');
    } else {
      $section.removeAttr('data-video-banner-visible');
    }
    deskVideoBannerSyncBackgroundVideos(entry.target);
  });
}

function deskVideoBannerFindPopup($triggerButton) {
  var $popup = $triggerButton.closest('[data-video-banner]').find('[data-video-banner-dialog]');

  if (!$popup.length) $popup = $(document.getElementById($triggerButton.attr('aria-controls')));
  return $popup;
}

function deskVideoBannerMovePopupToBody($popup) {
  var popupId = $popup.attr('id');

  if ($popup.parent().is('body')) return;
  $('body > [data-video-banner-dialog]').filter(function (index, stalePopup) {
    return stalePopup.id === popupId;
  }).remove();
  $popup.appendTo('body');
}

function deskVideoBannerPlayWithSound(videoElement) {
  videoElement.muted = false;
  videoElement.removeAttribute('muted');
  videoElement.volume = 1;
  deskVideoBannerSafePlay(videoElement);
}

function deskVideoBannerOpenPopup($triggerButton) {
  var bannerState = window.deskVideoBannerState;
  var $popup = deskVideoBannerFindPopup($triggerButton);
  var $section = $triggerButton.closest('[data-video-banner]');
  var $playerContainer;
  var $videoTemplate;
  var $popupVideo;

  if (!$popup.length || bannerState.$activePopup) return;

  deskVideoBannerMovePopupToBody($popup);
  $playerContainer = $popup.find('[data-video-banner-player]');
  $videoTemplate = $popup.find('[data-video-banner-template]');
  if ($playerContainer.length && $videoTemplate.length && !$playerContainer.children().length) {
    $playerContainer.append(document.importNode($videoTemplate[0].content, true));
  }

  bannerState.$activePopup = $popup;
  bannerState.$activeTrigger = $triggerButton;
  $triggerButton.attr('aria-expanded', 'true');
  $popup.removeAttr('hidden').addClass('is-open');

  if ($section.length) {
    $section.attr('data-video-banner-popup-open', '');
    deskVideoBannerSyncBackgroundVideos($section[0]);
  }
  if (typeof window.lockScroll === 'function') window.lockScroll();

  if (window.DeskA11y) {
    bannerState.releaseFocusTrap = window.DeskA11y.trapFocus($popup[0], {
      onEscape: deskVideoBannerClosePopup,
      returnFocusTo: $triggerButton[0]
    });
  } else {
    $popup.find('[data-video-banner-close]').trigger('focus');
  }

  $popupVideo = $playerContainer.find('video');
  if ($popupVideo.length) deskVideoBannerPlayWithSound($popupVideo[0]);
}

function deskVideoBannerClosePopup() {
  var bannerState = window.deskVideoBannerState;
  var $popup = bannerState.$activePopup;
  var $triggerButton = bannerState.$activeTrigger;
  var $section;
  var isTriggerInDocument;

  if (!$popup) return;

  $section = $(document.getElementById($popup.attr('data-video-banner-section')));
  $popup.find('[data-video-banner-player]').empty();
  $popup.removeClass('is-open').attr('hidden', '');
  if (typeof window.unlockScroll === 'function') window.unlockScroll();

  if ($section.length) {
    $section.removeAttr('data-video-banner-popup-open');
    deskVideoBannerSyncBackgroundVideos($section[0]);
  }

  isTriggerInDocument = !!($triggerButton && $triggerButton.length && $.contains(document.documentElement, $triggerButton[0]));
  if (isTriggerInDocument) $triggerButton.attr('aria-expanded', 'false');

  if (typeof bannerState.releaseFocusTrap === 'function') {
    bannerState.releaseFocusTrap();
  } else if (isTriggerInDocument) {
    $triggerButton[0].focus({ preventScroll: true });
  }

  bannerState.releaseFocusTrap = null;
  bannerState.$activeTrigger = null;
  bannerState.$activePopup = null;
}

function deskVideoBannerHandleOpenClick(event) {
  deskVideoBannerOpenPopup($(event.currentTarget));
}

function deskVideoBannerHandlePopupClick(event) {
  var $activePopup = window.deskVideoBannerState.$activePopup;
  var $clickTarget = $(event.target);
  var hasClickedClose;
  var hasClickedOutsideContent;

  if (!$activePopup || $activePopup[0] !== event.currentTarget) return;

  hasClickedClose = $clickTarget.closest('[data-video-banner-close]').length > 0;
  hasClickedOutsideContent = $clickTarget.closest('.desk_video-banner__inner').length === 0;
  if (hasClickedClose || hasClickedOutsideContent) deskVideoBannerClosePopup();
}

function deskVideoBannerHandleKeydown(event) {
  var $activePopup = window.deskVideoBannerState.$activePopup;
  var $focusableElements;
  var firstFocusable;
  var lastFocusable;

  if (!$activePopup || window.DeskA11y) return;

  if (event.key === 'Escape') {
    deskVideoBannerClosePopup();
    return;
  }
  if (event.key !== 'Tab') return;

  $focusableElements = $activePopup.find(DESK_VIDEO_BANNER_FOCUSABLE).filter(':visible');
  if (!$focusableElements.length) return;

  firstFocusable = $focusableElements[0];
  lastFocusable = $focusableElements[$focusableElements.length - 1];

  if (event.shiftKey && (document.activeElement === firstFocusable || !$.contains($activePopup[0], document.activeElement))) {
    event.preventDefault();
    lastFocusable.focus();
  } else if (!event.shiftKey && (document.activeElement === lastFocusable || !$.contains($activePopup[0], document.activeElement))) {
    event.preventDefault();
    firstFocusable.focus();
  }
}

function deskVideoBannerBindSections() {
  var bannerState = window.deskVideoBannerState;

  $('[data-video-banner]').not('[data-video-banner-bound]').each(function (index, sectionElement) {
    var $section = $(sectionElement);

    $section.attr('data-video-banner-bound', '');
    if (!$section.find('[data-video-banner-bg]').length) return;

    if (bannerState.visibilityObserver) {
      bannerState.visibilityObserver.observe(sectionElement);
    } else {
      $section.attr('data-video-banner-visible', '');
      deskVideoBannerSyncBackgroundVideos(sectionElement);
    }
  });
}

function deskVideoBannerHandleSectionUnload(event) {
  var bannerState = window.deskVideoBannerState;
  var $sectionWrapper = $(event.target);
  var $section = $sectionWrapper.is('[data-video-banner]')
    ? $sectionWrapper
    : $sectionWrapper.find('[data-video-banner]').first();
  var sectionId;

  if (!$section.length) return;
  sectionId = $section.attr('id');

  if (bannerState.visibilityObserver) bannerState.visibilityObserver.unobserve($section[0]);
  if (bannerState.$activePopup && bannerState.$activePopup.attr('data-video-banner-section') === sectionId) {
    deskVideoBannerClosePopup();
  }

  $('body > [data-video-banner-dialog]').filter(function (index, movedPopup) {
    return $(movedPopup).attr('data-video-banner-section') === sectionId;
  }).remove();
}

function deskVideoBannerWatchMediaQuery(mediaQuery) {
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', deskVideoBannerSyncAllSections);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(deskVideoBannerSyncAllSections);
  }
}

function deskVideoBannerInit() {
  var bannerState = window.deskVideoBannerState;

  if (bannerState.isReady) return;
  bannerState.isReady = true;

  if ('IntersectionObserver' in window) {
    bannerState.visibilityObserver = new IntersectionObserver(deskVideoBannerHandleIntersect, { rootMargin: '200px 0px' });
  }

  $(document)
    .on('click', '[data-video-banner-open]', deskVideoBannerHandleOpenClick)
    .on('click', '[data-video-banner-dialog]', deskVideoBannerHandlePopupClick)
    .on('keydown', deskVideoBannerHandleKeydown)
    .on('visibilitychange', deskVideoBannerSyncAllSections)
    .on('shopify:section:load', deskVideoBannerBindSections)
    .on('shopify:section:unload', deskVideoBannerHandleSectionUnload);

  deskVideoBannerWatchMediaQuery(DESK_VIDEO_BANNER_MOBILE_QUERY);
  deskVideoBannerWatchMediaQuery(DESK_VIDEO_BANNER_REDUCED_MOTION_QUERY);
  deskVideoBannerBindSections();
}

$(document).ready(deskVideoBannerInit);